import { SERVER_KEY_MAP } from 'configs/constants';
import isEmpty from 'lodash/isEmpty';
import { TServerIds } from 'models/types';
import { getCurrentPartId } from 'utils/getCurrentPartId';

type TDataArg = {
  success?: () => void,
  failure?: () => void,
  loading?: () => void,
  partId?: string;
  clickId?: string;
  operatorId: TServerIds;
};
type TMockArg = {
  failure?: boolean;
};

type TProps = (data: TDataArg, mock?: TMockArg) => void;

const subscribe: TProps = async (data, mock) => {
  if (!isEmpty(mock)) {
    if (mock.failure) {
      data.failure && data.failure();
      return { message: 'Failure', status: 'err' };
    } else {
      data.success && data.success();
      return { message: 'Success', status: 'ok' };
    }
  } else {
    data.loading && data.loading();
    const currentServer = SERVER_KEY_MAP[data.operatorId];
    if (currentServer.url === null) return;
    await fetch(`${currentServer.url}${currentServer.getParams}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        msg: {
          command: 'on',
          click_id: data.clickId,
          billing_marker: getCurrentPartId({ partId: data.partId, serverName: currentServer.name })
        }
      })
    }).then(response => response.json()).then(d => {
      data.success && data.success();
      return { message: 'success', status: 'ok' };
    }).catch(err => {
      data.failure && data.failure();
      return { message: err, status: 'err' };
    });
  }
};

export default subscribe;
